import {
  Alert,
  AlertDescription,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertIcon,
  Box,
  Button,
  Text
} from '@chakra-ui/react'
import { FC, useEffect, useRef, useState } from 'react'

import { JustificativaForaCronogramaField } from './ForaCronogramaReview'

interface Props {
  isOpen: boolean
  justificativaInicial?: string
  onClose: () => void
  onConfirm: (justificativa: string) => void
}

// Comprador com "Utilizar Cronograma" = Não: justificativa única obrigatória
// (não envia o pedido para aprovação por si só)
const ConfirmacaoCronogramaDialog: FC<Props> = ({
  isOpen,
  justificativaInicial = '',
  onClose,
  onConfirm
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null)
  const [justificativa, setJustificativa] = useState(justificativaInicial)

  useEffect(() => {
    if (isOpen) setJustificativa(justificativaInicial)
  }, [isOpen, justificativaInicial])

  const isValid = justificativa.trim().length > 0

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
      size="lg"
    >
      <AlertDialogOverlay>
        <AlertDialogContent bg="white">
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Não utilizar o Cronograma de Compras
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              As compras devem respeitar as datas programadas no{' '}
              <strong>Cronograma de Compras</strong>.
            </Text>

            <Alert status="warning" mt={3} borderRadius="md">
              <AlertIcon />
              <AlertDescription fontSize="sm">
                Para comprar fora do cronograma, informe a justificativa. Ela
                fica registrada no pedido.
              </AlertDescription>
            </Alert>

            <Box mt={4}>
              <JustificativaForaCronogramaField
                id="justificativa-fora-cronograma"
                label="Justificativa"
                value={justificativa}
                onChange={setJustificativa}
                placeholder="Informe o motivo para não utilizar o Cronograma de Compras"
                rows={4}
                autoFocus
              />
            </Box>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Cancelar
            </Button>
            <Button
              colorScheme="green"
              onClick={() => onConfirm(justificativa.trim())}
              isDisabled={!isValid}
              ml={3}
            >
              OK
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export default ConfirmacaoCronogramaDialog
